export default __webpack_public_path__ + "static/media/457.edb8ed18.jpg";